import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { validateEmail } from '../shared/helpers';
import { RequestService, LayoutUtilsService, LoaderService, StoreService } from '../shared/services';
import { ConfirmSelectEntityDialogComponent } from '../shared/components/modals';
import { ModalPasswordDialogComponent } from '../shared/components/custom-password-dialog/custom-password-dialog.component';
import { ModalRegistrationDialogComponent } from '../shared/components/custom-registration-dialog/custom-registration-dialog.component';
import { Moment } from 'moment';
import * as moment from 'moment';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  protected subscriptions: Subscription[] = [];
  public errorMessage: string = '';
  public loading: boolean = false;
  public passwordNeeded: boolean = false;
  public orgId = undefined;
  public organization = undefined;
  public language = 'en';
  public serverName = '';
  public enableTranslation = ""//environment.enableTranslation;
  public orgType = ""//environment.orgType;
  public lockSite = ""//environment.lockSite;
  public serverHostUrl = ""//environment.serverHostUrl;
  public s3BucketUrl = ""//environment.s3BucketUrl;
  public title = '';
  public subTitle = '';
  public email = '';
  public password = '';
  public returnUrl: string;
  public forgotPass: boolean = false;
  public currentDate: Moment = moment.utc();
  public loginDefaultImage = "../../../assets/images/new-logo-2.png";
  public loginImage = this.loginDefaultImage;
  public loginBGImage = {};
  public urlToken = '';
  showPassword = false;

  @ViewChild('emailInput') emailInp: MatInput;
  @ViewChild('passwordInput') passwordInp: MatInput;

  constructor(
    public dialog: MatDialog,
    public loadService: LoaderService,
    private layoutUtilsService:
      LayoutUtilsService,
    private requestService: RequestService,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private storeService: StoreService
  ) {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
    this.email = this.route.snapshot.queryParams['email'] || '';
    this.urlToken = this.route.snapshot.queryParams['token'] || '';
  }

  ngOnInit() {
    if (this.storeService.get('currentUser') && this.storeService.get('token')) {
      this.router.navigate([this.returnUrl]);
    } else {
      this.subscriptions.push(
        this.activatedRoute.params.subscribe(params => {
          if (params.hasOwnProperty('orgId')) {
            this.requestService.loginEnteredIds = { orgId: params.orgId };
            this.requestService.orgId = params['orgId'];
            this.orgId = params['orgId'];
            localStorage.setItem('o', JSON.stringify(params.orgId));
            this.initBGLogo();
            this.initLogo();
            if (params.hasOwnProperty('appId') && params.hasOwnProperty('locId') && params.hasOwnProperty('lang')) {
              this.requestService.loginEnteredIds['appId'] = params.appId;
              this.requestService.loginEnteredIds['locId'] = params.locId;
              this.requestService.loginEnteredIds['lang'] = params.lang;
              this.requestService.appId = params['appId'];
              this.requestService.locId = params['locId'];
              this.requestService.lang = params['lang'];
              this.translate.use(params['lang']);
              this.language = params['lang'];
              localStorage.setItem('a', JSON.stringify(params.appId));
              localStorage.setItem('l', JSON.stringify(params.locId));
              localStorage.setItem('lang', JSON.stringify(params.lang));
            }
            sessionStorage.setItem('loginEnteredIds', JSON.stringify(this.requestService.loginEnteredIds));

            if (this.urlToken && this.urlToken !== '') {
              this.onLoginWithToken(this.urlToken);
            } else if (this.email && this.email !== '') {
              this.onLogin(undefined);
            }
          } else {
            this.requestService.loginEnteredIds = undefined;
            sessionStorage.removeItem('loginEnteredIds');
            this.language = this.requestService.lang;
          }
        })
      );
      this.subscriptions.push(
        this.activatedRoute.parent.url.subscribe(url => {
          if (url && url.length > 0) {
            if (url[0].path === 'login') {
              this.dialog.closeAll();
            }
          }
        })
      );
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach(el => el.unsubscribe());
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.emailInp.focus();
    }, 100);
  }
  setLanguage(lang) {
    this.translate.setDefaultLang(lang);
    this.translate.use(lang)
    this.requestService.lang = lang;
    this.language = lang;
    localStorage.setItem('lang', JSON.stringify(lang));
  }

  cancelThru(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  public initBGLogo() {
    let orgId = this.requestService.orgId;
    if (orgId) {
      let imgPath = this.s3BucketUrl + this.orgType + "/" + orgId + "/loginbg.jpg";
      this.loginBGImage = { backgroundImage: 'url(' + imgPath + ')' };
    }
  }
  public initLogo() {
    let orgId = this.requestService.orgId;
    if (orgId) {
      this.loginImage = this.s3BucketUrl + this.orgType + "/" + orgId + "/new-logo-2.png";
    } else {
      this.loginImage = "assets/vertical/" + this.orgType + "/images/new-logo-2.png";
    }
  }

  public setEmailFocus() {
    this.passwordNeeded = false;
    setTimeout(() => {
      this.emailInp.focus();
    }, 100);
  }
  public setForgotPassFocus(st) {
    this.forgotPass = st;
    if (st) {
      setTimeout(() => {
        this.emailInp.focus();
      }, 100);
    } else {
      setTimeout(() => {
        this.passwordInp.focus();
      }, 100);
    }
  }
  public gToSignUp(st) {
    this.router.navigateByUrl('/register');
  }
  public validateUser(userData) {
    if (userData.hasOwnProperty('organizationId')) {
      if (userData.organizationId.length > 0) {
        if (this.requestService.loginEnteredIds) {
          if (this.requestService.checkListContains(userData.organizationId, this.requestService.loginEnteredIds.orgId)) {
            this.loadOrganization(userData, this.requestService.loginEnteredIds.orgId);
          } else {
            this.goToRegister();
          }
        } else {
          if (userData.organizationId.length > 1) {
            this.continueSelectOrg(userData, userData.organizationId);
          } else {
            this.loadOrganization(userData, userData.organizationId[0]._id);
          }
        }
        return;
      }
    }
    this.layoutUtilsService.showNotification('You have no access to this site', this.translate.instant('Dismiss'));
    this.requestService.authenticatedUser.next(false);
  }
  // Gets the app from organization
  public getAppToSelect(orgId) {
    this.requestService.getSingleCachData('organization', orgId, (data, error) => {
      if (error) {
        this.errorMessage = error;
      }
      if (data) {
        // document.title = data.name;
        if (data.isOpenForRegistration) { // if the registeration is open
          if (!this.requestService.appId && !this.requestService.loginEnteredIds.appId && !this.requestService.locId && !this.requestService.loginEnteredIds.locId) {
            if (data.hasOwnProperty('apps') && data.apps.length > 0) {
              this.requestService.appId = data.apps[0]._id;
              this.getLocToSelect(this.requestService.appId);
            } else {
              this.layoutUtilsService.showNotification(this.translate.instant('Organization structure is missing please contact the administrator'), this.translate.instant('Dismiss'));
              this.requestService.authenticatedUser.next(false);
            }
          } else {
            this.continueToRegister();
          }
        } else {
          this.requestService.authenticatedUser.next(false);
          this.layoutUtilsService.showNotification(this.translate.instant('Your email doesn\'t exist'), this.translate.instant('Dismiss'));
        }
      }
    }, true);
  }
  public getLocToSelect(appId) {
    this.requestService.getSingleCachData('app', appId, (data, error) => {
      if (error) {
        this.errorMessage = error;
      }
      if (data) {
        if (data.hasOwnProperty('locations')) {
          if (data.locations.length > 0) {
            this.requestService.locId = data.locations[0]._id;
            this.requestService.lang = 'en';
            this.continueToRegister();
            return;
          }
        }
        this.layoutUtilsService.showNotification(this.translate.instant('Application structure is missing please contact the administrator'), this.translate.instant('Dismiss'));
        this.requestService.authenticatedUser.next(false);
      }
    }, false);
  }
  public goToRegister() {
    //Test for registeration
    this.getAppToSelect(this.requestService.orgId);
  }
  public continueToRegister() {
    const dialogRef = this.dialog.open(ModalRegistrationDialogComponent, {
      width: '600px',
      data: {
        dataType: 'resource/user',
        dataTypeTitle: this.translate.instant('Register'),
        title: this.translate.instant('Welcome to Stellar. Please fill in the following to complete your registration'),
        data: {},
        modalSetting: this.getUserSetting({}, this.getUserCustomFilter())
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.registerUser(result.data);
      }
    });

  }
  private getUserSetting(data, filters) {
    let tableSetting = data;
    tableSetting['target'] = 'parent';
    if (filters)
      tableSetting['filters'] = filters;
    tableSetting['customSettings'] =
    {
      organizationId: { visible: false, value: [{ _id: this.requestService.orgId, name: '' }] },
      resources: { visible: false, value: [{ _id: environment.customKeys.roleView, organizationId: this.requestService.orgId, name: '' }] },
      appId: { visible: false, value: [{ _id: this.requestService.appId, organizationId: this.requestService.orgId, name: '' }] }, locationId: { visible: false, value: [{ _id: this.requestService.locId, appId: this.requestService.appId, name: '' }] },
      email: { visible: false, value: this.email.trim() },

    };
    return tableSetting;
  }
  private getUserCustomFilter() {
    let filters = {};
    filters['$and'] = [{ "organizationId._id": { "$in": [this.requestService.orgId] } }];
    return filters;
  }
  registerUser(editedUser) {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      this.requestService.signUp(this.requestService.loginEnteredIds.orgId, editedUser, (data, error) => {
        this.loading = false;
        if (error) {
          this.errorMessage = error;
          this.layoutUtilsService.showNotification(error, 'Dismiss');
        }
        if (data) {
          if (data.changepassword) {
            this.changePassword(data);
          } else {
            this.validateUser(data);
          }
        }
      }, environment.customKeys.roleView);
    }
  }
  public loadOrganization(userData, orgId) {
    if (!this.loading) {
      this.requestService.orgId = orgId;
      localStorage.setItem('o', JSON.stringify(orgId));
      this.loading = true;
      this.loadService.display(true);
      this.errorMessage = '';
      this.requestService.getSingleCachData('organization', orgId, (data, error) => {
        if (error) {
          this.errorMessage = error;
        }
        this.loading = false;
        this.loadService.display(false);
        if (data) {
          if (data.hasOwnProperty('apps')) {
            if (data.apps.length > 0) {
              let currentUserRole = this.requestService.getUserRoleByUserData(userData);
              let startDate = moment.utc(data.startDate);
              let endDate = moment.utc(data.endDate);
              let orgOpened = this.currentDate.diff((startDate), 'minutes') >= 0 && endDate.diff((this.currentDate), 'minutes') >= 0;
              if (!this.lockSite || (this.lockSite && (orgOpened || (!orgOpened && data.isAvailableOffline))) || currentUserRole === 'admin') {
                this.requestService.pageOrganization.next(data);
                localStorage.setItem('org', JSON.stringify(data));
                let userAppListIds = this.requestService.getDataFromList(userData.appId);
                let userAppList = this.requestService.getDataFromListContains(data.apps, userAppListIds);
                if (userAppList.length > 0) {
                  if (this.requestService.loginEnteredIds && this.requestService.loginEnteredIds.hasOwnProperty('appId')) {
                    if (this.requestService.checkListContains(userAppList, this.requestService.loginEnteredIds.appId)) {
                      this.loadApplication(userData, this.requestService.loginEnteredIds.appId);
                    } else {
                      this.layoutUtilsService.showNotification(this.translate.instant('You don\'t have access to this application for this organization'), this.translate.instant('Dismiss'));
                    }
                  } else {
                    if (userAppList.length > 1) {
                      this.continueSelectApp(userData, userAppList);
                    } else {
                      this.loadApplication(userData, userAppList[0]._id);
                    }
                  }
                } else {
                  this.layoutUtilsService.showNotification(this.translate.instant('You don\'t have access to any application in this organization'), this.translate.instant('Dismiss'));
                }
              } else {
                this.layoutUtilsService.showNotification(this.translate.instant('This organization is not currently available.'), this.translate.instant('Dismiss'));
                this.requestService.authenticatedUser.next(false);
              }
              return;
            }
          }
          this.layoutUtilsService.showNotification(this.translate.instant('Organization structure is missing please contact the administrator'), this.translate.instant('Dismiss'));
          this.requestService.authenticatedUser.next(false);
        }
      }, true);
    }

  }
  onLoginWithPassword(e) {
    if (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      this.password = e.target.value;
    }
    if (this.email !== '' && this.password !== '') {
      this.loadUser();
    } else {
      this.layoutUtilsService.showNotification(this.translate.instant('Fill in email and password'), this.translate.instant('Dismiss'));
    }
  }
  handleEmailEnter(e) {
    if (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      this.email = e.target.value;
    }
    if (this.forgotPass) {
      this.onForgotPass();
    } else {
      this.onLogin(undefined);
    }
  }
  onLogin(e) {
    if (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      this.email = e.target.value;
    }
    if (this.email !== '' && validateEmail(this.email.trim())) {
      this.passwordNeeded = true;
      setTimeout(() => {
        this.passwordInp.focus();
      }, 100);
    } else {
      this.layoutUtilsService.showNotification(this.translate.instant('Fill in correct email format'), this.translate.instant('Dismiss'));
    }
  }
  public loadUserCheck() {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      this.requestService.requestLoginCheck(this.email.trim(), this.password, (data, error) => {
        if (error) {
          this.layoutUtilsService.showNotification(this.translate.instant('Wrong Login Credentials'), this.translate.instant('Dismiss'));
          this.requestService.authenticatedUser.next(false);
          this.loading = false;
          return;
        }
        if (data) {
          this.loading = false;
          if (data.hasOwnProperty('already_login') && data.already_login) {
            this.alreadyLoggedIn(this.translate.instant('Already Logged In'), this.translate.instant('Looks like your logged in somewhere else.'));
          } else {
            let userData = data;
            if (userData.changepassword) {
              this.changePassword(userData);
            } else {
              this.validateUser(userData);
            }
          }
        } else {
          this.layoutUtilsService.showNotification(this.translate.instant('Wrong Login'), this.translate.instant('Dismiss'));
          this.requestService.authenticatedUser.next(false);
        }
        this.loading = false;
      });
    }
  }
  alreadyLoggedIn(title: string, msg: string) {
    let alertSetting = {};
    alertSetting['overlayClickToClose'] = false;
    alertSetting['showCloseButton'] = false;
    alertSetting['confirmText'] = this.translate.instant('Login in here instead');
    alertSetting['declineText'] = this.translate.instant('Cancel');

    const dialogRef = this.layoutUtilsService.alertActionElement(title, msg, alertSetting, '500px');
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res.action === 'confirmText') {
          this.loadUser();
        }
      }
    });
  };
  public loadUser() {
    if (!this.loading) {
      if (this.password !== '') {
        this.loading = true;
        this.errorMessage = '';
        this.requestService.requestLoginClient(this.email.trim(), this.password, (data, error) => {
          this.clearStorage()
          if (error) {
            this.requestService.authenticatedUser.next(false);
            this.loading = false;
            this.layoutUtilsService.showNotification(this.translate.instant('Wrong Login Credentials'), this.translate.instant('Dismiss'));
            return;
          }
          if (data) {
            let userData = data;
            this.loading = false;

            this.storeService.set('currentUser', userData);
            this.requestService.currentUser = userData;
            this.requestService.authenticatedUser.next(true);
            if (userData.reset_requested) {
              this.router.navigateByUrl('/dashboard/account?reset=true');
            }
            else {
              if (userData.type == "1" || userData.isSuperAdmin == "1") {
                this.router.navigateByUrl('/reseller/dashboard');
                return;
              }
              this.router.navigateByUrl('/dashboard');
            }
          } else {
            this.layoutUtilsService.showNotification(this.translate.instant('Wrong Login'), this.translate.instant('Dismiss'));
            this.requestService.authenticatedUser.next(false);
          }
          this.loading = false;
        });

      } else {
        this.layoutUtilsService.showNotification(this.translate.instant('Fill in your password'), this.translate.instant('Dismiss'));
      }
    }
  }

  onLoginWithToken(token) {
    if (token !== '') {
      this.loadTokenUser(token);
    } else {
      this.layoutUtilsService.showNotification(this.translate.instant('Wrong Login Credentials'), this.translate.instant('Dismiss'));
    }
  }
  public loadTokenUser(token) {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      this.requestService.requestLoginTokenCheck(token, (data, error) => {
        if (error) {
          this.layoutUtilsService.showNotification(this.translate.instant('Wrong Login Credentials'), this.translate.instant('Dismiss'));
          this.requestService.authenticatedUser.next(false);
          this.loading = false;
          return;
        }
        if (data) {
          let userData = data;
          this.loading = false;
          this.storeService.set('currentUser', userData);
          this.requestService.currentUser = userData;

          if (userData.type == "1" || userData.isSuperAdmin == "1") {
            this.router.navigateByUrl('/reseller/dashboard');
            return;
          }
          this.router.navigate([this.returnUrl]);
        } else {
          this.layoutUtilsService.showNotification(this.translate.instant('Wrong Login'), this.translate.instant('Dismiss'));
          this.requestService.authenticatedUser.next(false);
        }
        this.loading = false;
      });
    }
  }


  browserNotSupported(title: string, msg: string) {
    let alertSetting = {};
    alertSetting['overlayClickToClose'] = false;
    alertSetting['showCloseButton'] = false;
    const dialogRef = this.layoutUtilsService.alertActionElement(title, msg, '500px');
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        res = { value: undefined };
      }
    });
  };
  onForgotPass() {
    if (!this.loading) {
      this.loading = true;
      this.errorMessage = '';
      this.requestService.forgotPassword(this.email.trim(), (data, error, returnIt) => {
        if (error) {
          this.errorMessage = error;
          this.layoutUtilsService.showNotification(error, 'Dismiss');
          this.checkAuth(returnIt);
        }
        if (data) {
          this.forgotPass = false;
          this.changePasswordWithVerify();
          this.layoutUtilsService.showNotification(this.translate.instant('Please check your email for a verification code to change your password.'), 'Dismiss');
        }
        this.loading = false;
      });
    }
  }
  private checkAuth(returnIt) {
    if (returnIt) {
      this.forgotPass = false;
    }
  }
  changePassword(userData) {
    const dialogRef = this.dialog.open(ModalPasswordDialogComponent, {
      width: '300px',
      disableClose: true,
      data: {
        title: this.translate.instant('Change Password')
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.validateUser(userData);
      }
    });
  }
  changePasswordWithVerify() {
    const dialogRef = this.dialog.open(ModalPasswordDialogComponent, {
      width: '300px',
      disableClose: true,
      data: {
        title: this.translate.instant('Change Password'),
        toVerify: true,
        email: this.email
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('afterClosed', result);
      if (result) {
        // do nothing
        this.layoutUtilsService.showNotification(this.translate.instant('Your password has been reset successfully.'), 'Dismiss');
      }
    });
  }
  continueSelectOrg(userData, selectData) {
    const dialogRef = this.dialog.open(ConfirmSelectEntityDialogComponent, {
      width: '600px',
      disableClose: true,
      data: {
        title: this.translate.instant('Select') + ' ' + environment.identityName,
        data: this.requestService.orgId,
        dataList: selectData,
        placeholder: this.translate.instant('Select') + ' ' + environment.identityName,
        cancelbtn: this.translate.instant('Cancel'),
        confirmbtn: this.translate.instant('Confirm'),
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.loadOrganization(userData, res._id);
      } else {
        this.requestService.logout();
      }
    });
  }
  continueSelectApp(userData, selectData) {
    const dialogRef = this.dialog.open(ConfirmSelectEntityDialogComponent, {
      width: '600px',
      disableClose: true,
      data: {
        title: 'Select ' + environment.identityName,
        data: this.requestService.appId,
        dataList: selectData,
        placeholder: 'Select ' + environment.identityName,
        cancelbtn: this.translate.instant('Cancel'),
        confirmbtn: this.translate.instant('Confirm'),
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.loadApplication(userData, res._id);
      } else {
        this.requestService.logout();
      }
    });
  }
  public loadApplication(userData, appId) {
    let userLocList = this.requestService.getDataFromListContains(userData.locationId, [appId], 'appId');
    if (userLocList.length > 0) {
      this.requestService.appId = appId;
      localStorage.setItem('a', JSON.stringify(appId));

      this.requestService.locId = userLocList[0]._id;
      localStorage.setItem('l', JSON.stringify(userLocList[0]._id));

      localStorage.setItem('currentUser', JSON.stringify(userData));
      this.requestService.appStatusSubject.next(undefined);
      this.requestService.currentUser = userData;

      let resource = this.requestService.getItemFromListContains(userData.resources, this.requestService.orgId, 'organizationId');
      this.requestService.updatePermissions(resource);
      sessionStorage.setItem('live', JSON.stringify(true));
      this.requestService.authenticatedUser.next(true);
      this.router.navigate([this.returnUrl]);
    } else {
      this.layoutUtilsService.showNotification(this.translate.instant('You don\'t have access to any location in this application'), this.translate.instant('Dismiss'));
      this.requestService.authenticatedUser.next(false);
    }
  }
  //below not being used
  public loadApplicationOld(userData, appId) {
    if (!this.loading) {
      this.requestService.appId = appId;
      localStorage.setItem('a', JSON.stringify(appId));
      this.loading = true;
      this.loadService.display(true);
      this.errorMessage = '';
      this.requestService.getSingleCachData('app', appId, (data, error) => {
        if (error) {
          this.errorMessage = error;
        }
        this.loading = false;
        this.loadService.display(false);
        if (data) {
          if (data.hasOwnProperty('locations')) {
            if (data.locations.length > 0) {
              let userLocListIds = this.requestService.getDataFromList(userData.locationId);
              let userLocList = this.requestService.getDataFromListContains(data.locations, userLocListIds);
              if (userLocList.length > 0) {
                this.requestService.locId = userLocList[0]._id;
                localStorage.setItem('l', JSON.stringify(userLocList[0]._id));

                localStorage.setItem('currentUser', JSON.stringify(userData));
                this.requestService.appStatusSubject.next(undefined);
                this.requestService.currentUser = userData;
                this.requestService.authenticatedUser.next(true);
                this.router.navigate([this.returnUrl]);
                return;
              } else {
                this.layoutUtilsService.showNotification(this.translate.instant('You don\'t have access to any location in this application'), this.translate.instant('Dismiss'));
              }
              return;
            }
          }
          this.layoutUtilsService.showNotification(this.translate.instant('Application structure is missing please contact the administrator'), this.translate.instant('Dismiss'));
          this.requestService.authenticatedUser.next(false);

          if (data.hasOwnProperty('locations')) {
            if (data.locations.length > 0) {
              this.requestService.locId = data.locations[0]._id;
              localStorage.setItem('l', JSON.stringify(data.locations[0]._id));

              localStorage.setItem('currentUser', JSON.stringify(userData));
              this.requestService.appStatusSubject.next(undefined);
              this.requestService.currentUser = userData;
              this.requestService.authenticatedUser.next(true);
              this.router.navigate([this.returnUrl]);
              return;
            }
          }
          this.layoutUtilsService.showNotification(this.translate.instant('Application structure is missing please contact the administrator'), this.translate.instant('Dismiss'));
          this.requestService.authenticatedUser.next(false);

        }
      }, true);
    }

  }

  private clearStorage() {
    if (localStorage.getItem('default')) {
      localStorage.removeItem('default');
    }
  }
  toggleShow() {
    this.showPassword = !this.showPassword;
    this.passwordInp.type = this.showPassword ? 'text' : 'password';
  }
}
